export const searchSpecies = (speciesList = [], query = '') => {
  const normalizedQuery = String(query || '').trim().toLowerCase()

  if (!normalizedQuery) {
    return speciesList
  }

  return speciesList.filter((species) => {
    const scientificName = String(species.scientificName || '').toLowerCase()
    const commonName = String(species.specieName || species.commonName || '').toLowerCase()

    return scientificName.includes(normalizedQuery) || commonName.includes(normalizedQuery)
  })
}
